"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    CodeNotFound: 0,
    Success: 1,
    AnotherCodeAlreadySet: 2,
    CodeNotValidForCustomerType: 3
};
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/linksoft-albatros/src/CouponResponse.js
// module id = 410
// module chunks = 0 1 2